import React from 'react';

const HomeAboutAward = () => {
    return (
        <div>
            <h2 className='text-color text-center'>Award Upcoming Soon...</h2>
        </div>
    );
};

export default HomeAboutAward;